import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'

import classes from './ContentGearTip.module.scss'

const ContentGearTip = ({ title, children }) => {
  return (
    <div className={clsx('ContentGearTip', classes.root)}>
      <div className={classes.titleContainer}>
        <Icon icon={['far', 'cog']} className={classes.cog} />
        <h3 className={classes.title}>{title}</h3>
      </div>
      <div className={classes.content}>{children}</div>
    </div>
  )
}

export default ContentGearTip
